import APP_COMPONENTS from "../components/index.js";
export default {
    execute: async () => {
        const newIndex = APP_COMPONENTS.eventForms.add();
        APP_COMPONENTS.fileForms.add(newIndex);
        APP_COMPONENTS.progressComponents.add(newIndex);
    }
};
